import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Menu, Plus } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useChat } from "@/context/ChatContext";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { AREE, sectionOf, canOpen } from "@/components/shell/navConfig";
import { railItemsFor, isRailActive } from "@/components/shell/LeftRail";
import { strumentiFor } from "@/components/shell/StrumentiMenu";
import { useOpenApp } from "@/components/shell/useOpenApp";
import { AppIcon } from "@/components/AppIcon";

const Titolo = ({ children }) => <p className="px-2 pt-4 pb-1 text-[11px] uppercase tracking-wider font-semibold text-slate-500">{children}</p>;

export const MobileMenu = () => {
  const [open, setOpen] = useState(false);
  const { user, apps } = useAuth();
  const { isInternal } = useChat();
  const { pathname } = useLocation();
  const nav = useNavigate();
  const openApp = useOpenApp();
  const go = (to) => { setOpen(false); nav(to); };
  const voce = "w-full flex items-center gap-3 rounded-lg px-2 py-2.5 text-sm text-left transition-colors";

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <button className="lg:hidden h-10 w-10 rounded-lg flex items-center justify-center text-navy hover:bg-sage" aria-label="Apri menu" data-testid="mobile-menu-btn"><Menu className="h-5 w-5" /></button>
      </SheetTrigger>
      <SheetContent side="left" className="w-[300px] overflow-y-auto p-4" data-testid="mobile-menu">
        <SheetHeader><SheetTitle className="text-navy text-left">Menu</SheetTitle></SheetHeader>
        {railItemsFor(user, apps).map((i) => (
          <button key={i.key} onClick={() => go(i.to)} data-testid={`mobile-rail-${i.key}`} className={`${voce} ${isRailActive(pathname, i.to) ? "bg-navy text-white" : "text-slate-700 hover:bg-sage"}`}>
            <i.icon className="h-4 w-4" /> {i.label}
          </button>
        ))}
        {canOpen(user, apps, "/trattative") && (
          <button onClick={() => go("/trattative?nuova=1")} data-testid="mobile-nuova-trattativa" className={`${voce} font-semibold text-[#0B7770] hover:bg-sage`}><Plus className="h-4 w-4" /> Nuova trattativa</button>
        )}
        {AREE.map((a) => {
          const list = (apps || []).filter((x) => sectionOf(x) === a.key);
          if (!list.length) return null;
          return (
            <div key={a.key} data-testid={`mobile-area-${a.key}`}>
              <Titolo><span className="inline-block h-2 w-2 rounded-full mr-1.5" style={{ backgroundColor: a.color }} />{a.label}</Titolo>
              {list.map((x) => (
                <button key={x.app_id} onClick={() => { setOpen(false); openApp(x); }} className={`${voce} text-slate-700 hover:bg-sage`} data-testid={`mobile-app-${x.app_id}`}>
                  <AppIcon name={x.icon} className="h-4 w-4 text-navy" /> {x.name}
                </button>
              ))}
            </div>
          );
        })}
        <Titolo>Strumenti</Titolo>
        {strumentiFor(user, apps, isInternal).map((s) => (
          <button key={s.to} onClick={() => go(s.to)} className={`${voce} text-slate-700 hover:bg-sage`} data-testid={`mobile-strumento-${s.to.slice(1)}`}><s.icon className="h-4 w-4 text-navy" /> {s.label}</button>
        ))}
      </SheetContent>
    </Sheet>
  );
};
